import {connect} from "react-redux";
import {addSearchSecondaryFilterAction, removeSearchSecondaryFilterAction} from "../actions";
import {searchFiltersSelector} from "../selectors";
import SearchFiltersComponent from "../components/SearchFiltersComponent";
import {changeSearchFilterType} from "../middlewares";
import {userByIdSelector} from "../../_data/selectors";
import {currentUserIdSelector} from "../../user/selectors";

const mapStateToProps = (state, props) => {
    const search = searchFiltersSelector(state);
    const currentUser = userByIdSelector(state, currentUserIdSelector(state));
    return {
        selectedType: search.typeFilter,
        secondaryFilters: search.secondaryFilters,
        currentUser: currentUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeFilterType: (type: string) => {
            dispatch(changeSearchFilterType(type));
        },
        toggleSecondaryFilter: (e: React.FormEvent<HTMLInputElement>) => {
            const target = e.currentTarget;
            const action = target.checked ? addSearchSecondaryFilterAction : removeSearchSecondaryFilterAction;
            dispatch(action({secondaryFilter: target.value}));
        }
    }
};

const SearchFiltersContainer = connect(mapStateToProps, mapDispatchToProps)(SearchFiltersComponent);
export default SearchFiltersContainer;


// WEBPACK FOOTER //
// ./app/client/search/containers/SearchFiltersContainer.tsx